import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

// Keycloak's onLoad:'login-required' (see App.js) defaults to using the full current URL,
// query string included, as the post-login return address. /authorize's query string is a
// full nested OAuth request (an MCP client's redirect_uri, code_challenge, etc.) and gets
// long enough to break the round trip through Keycloak (observed as a 502 immediately after
// login, before the browser ever gets back to this app). Stash it and shorten the URL before
// Keycloak's login check ever sees it; Authorize.js reads it back out of sessionStorage.
if (window.location.pathname === '/authorize' && window.location.search) {
  window.sessionStorage.setItem('pendingAuthorize', window.location.search);
  window.history.replaceState(null, '', '/authorize');
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
